import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { CurrencyTD, LargeOnly, Td, Tr } from "commons";

export class TotalTR extends PureComponent {
    renderIncomeHistoryTotal = () => (
        <LargeOnly enabled={this.props.isClientPortal}>
            <Tr className="total-row">
                <Td />
                <Total>Total</Total>
                <TotalCurrency amount={this.props.amount === 0 ? null : this.props.amount} />
                <Td />
            </Tr>
        </LargeOnly>
    );

    render() {
        return this.props.isIncomeHistory ? (
            this.renderIncomeHistoryTotal()
        ) : (
            <LargeOnly enabled={this.props.isClientPortal}>
                <Tr className="total-row">
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Total>Total</Total>
                    <TotalCurrency
                        amount={this.props.feesAmount === 0 ? null : this.props.feesAmount}
                    />
                    <TotalCurrency amount={this.props.amount === 0 ? null : this.props.amount} />
                    <Td />
                </Tr>
            </LargeOnly>
        );
    }
}

export const Total = styled.td`
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: center;
    font-weight: 700;
`;

export const TotalCurrency = styled(CurrencyTD)`
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    font-weight: 700;
`;

TotalTR.propTypes = {
    amount: PropTypes.number,
    feesAmount: PropTypes.number,
    isClientPortal: PropTypes.bool,
    isIncomeHistory: PropTypes.bool
};
